import { CREATE_USER_PERMISSION } from "../constants/permissions";

 export const permissions = (state, action) => (
    {
        permissions:  [ CREATE_USER_PERMISSION ]
    }
);